import { SubscriptionPage } from "../pages/subscription";
import { SuccessPage } from "../pages/succeess";
import { DeclinedPage } from "../pages/declined";

export const stripeRoutes = [
  {
    path: "/subscription",
    Component: SubscriptionPage,
    exact: true,
    isPrivate: false,
  },
  {
    path: "/enroll",
    Component: SubscriptionPage,
    exact: true,
    isPrivate: false,
  },
  {
    path: "/success",
    Component: SuccessPage,
    exact: false,
    isPrivate: false,
  },
  {
    path: "/declined",
    Component: DeclinedPage,
    exact: false,
    isPrivate: false,
  },
  {
    path: "/congrats",
    Component: SuccessPage,
    exact: false,
    isPrivate: false,
  },
];
